import { extractCityFromAddress, extractStateFromAddress } from "helpers/extract-info-from-address";

export const extractOrderPlanLocation = (address?: string) => {
  const restrictedCity = RestrictedCityAlias[extractCityFromAddress(address)?.toLowerCase()] ?? '';

  return restrictedCity || extractStateFromAddress(address); 
};

export const RestrictedCityAlias = {
  ['new york']: 'NYC'
};
